
<script>
export default {
  name: 'TimeField',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    displaySeconds: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    menu: false
  }),
  computed: {
    time: {
      get () {
        let time = this.value;
        if (typeof time !== 'string') {
          return '';
        }
        if (!this.displaySeconds) {
          time = time.replace(/:\d*$/, '');
        }
        return time;
      },
      set (val) {
        if (/\d?\d:\d\d(:\d\d)?/.test(val)) {
          this.value = val;
        }
      }
    },
    hours: {
      get () {
        try {
          return this.value.split(':')[0];
        } catch (e) {
          return '';
        }
      },
      set (val) {
        val = this.minMax(val, 23, 0);
        this.setTime(val, this.minutes, this.seconds);
      }
    },
    minutes: {
      get () {
        try {
          return this.value.split(':')[1];
        } catch (e) {
          return '';
        }
      },
      set (val) {
        val = this.minMax(val, 59, 0);
        this.setTime(this.hours, val, this.seconds);
      }
    },
    seconds: {
      get () {
        try {
          return this.value.split(':')[2];
        } catch (e) {
          return '';
        }
      },
      set (val) {
        val = this.minMax(val, 59, 0);
        this.setTime(this.hours, this.minutes, val);
      }
    }
  },
  methods: {
    setTime (hours, minutes, seconds) {
      this.$emit('input', this.padStart(hours) + ':' + this.padStart(minutes) + ':' + this.padStart(seconds));
    },
    clearValue () {
      this.$emit('input', null);
    },
    padStart (val) {
      if (val === null || val === undefined || val === '') {
        return '';
      } else {
        return ('' + val).padStart(2, '0');
      }
    },
    minMax (val, max, min = 0) {
      if (val === null || val === undefined) {
        return undefined;
      } else {
        return Math.max(Math.min(val, max), min);
      }
    }
  }

};
</script>

<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    min-width="20px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="mdi-clock-outline"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon @click="clearValue()">
            mdi-close
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <div class="menu-content">
      <div class="input-group">
        <v-text-field
          v-model="hours"
          class="time-input"
          type="number"
          label="HH"
        >
          <template v-slot:prepend>
            <v-icon @click="hours = +hours+1">
              mdi-chevron-up
            </v-icon>
          </template>
          <template v-slot:append-outer>
            <v-icon @click="hours = +hours-1">
              mdi-chevron-down
            </v-icon>
          </template>
        </v-text-field>
        <span>:</span>
        <v-text-field
          v-model="minutes"
          class="time-input"
          type="number"
          label="MM"
        >
          <template v-slot:prepend>
            <v-icon @click="minutes = +minutes+1">
              mdi-chevron-up
            </v-icon>
          </template>
          <template v-slot:append-outer>
            <v-icon @click="minutes = +minutes-1">
              mdi-chevron-down
            </v-icon>
          </template>
        </v-text-field>
        <span v-if="displaySeconds">:</span>
        <v-text-field
          v-if="displaySeconds"
          v-model="seconds"
          class="time-input"
          type="number"
          label="SS"
        >
          <template v-slot:prepend>
            <v-icon @click="seconds = +seconds+1">
              mdi-chevron-up
            </v-icon>
          </template>
          <template v-slot:append-outer>
            <v-icon @click="seconds = +seconds-1">
              mdi-chevron-down
            </v-icon>
          </template>
        </v-text-field>
      </div>
      <v-spacer />
      <v-btn
        @click="menu = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="$refs.menu.save(value)"
      >
        OK
      </v-btn>
    </div>
  </v-menu>
</template>

<style lang="scss">
.input-group{
  display: flex;
  align-items: center;
}

.time-input{
  max-width: 4em;
  flex-direction: column;
  align-items: center;
  margin: 0.3em 0.5em;
  input{
  text-align: center;

  }
  &>*{
    margin:0 !important;
  }
}

.menu-content{
  padding: 0.5em;

  .v-btn {
    margin: 0.3em;
  }
}
</style>
